"use client";
import { useLocale } from "next-intl";
import useLocaleSwitcherModal from "../hooks/useLocaleSwitcherModal";
import Icon from "../../../modules/common/components/Icon";

const LocaleSwitcher = ({ displayIs0 = false, asMenuItem = false }) => {
  const locale = useLocale();
  const { openLocaleSwitcher, supportedLocales, LocaleSwitcherModal } =
    useLocaleSwitcherModal();
  return (
    <>
      <button
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          openLocaleSwitcher();
        }}
        className={`d-flex align-items-center gap-2 ${
          asMenuItem ? "publicare-menu-item" : ""
        }`}
        style={
          asMenuItem
            ? {
                fontSize: "inherit",
                fontFamily: "inherit",
                fontWeight: "inherit",
                padding: "0.5rem 1rem",
                margin: "-0.5rem -1rem",
                width: "calc(100% + 2rem)",
                justifyContent: "space-between",
              }
            : {}
        }
      >
        {displayIs0 ? locale : supportedLocales[locale]}
        <Icon icon="chevron-small" className="icon--md" />
      </button>
      {LocaleSwitcherModal}
    </>
  );
};

export default LocaleSwitcher;
